import * as React from "react";
import styled from "styled-components";
import { breakpoints, heights } from "../styles/variables";

const StyledLayoutMain = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: ${heights.header.mobile}px;
  padding-top: 30px;

  @media screen AND (min-width: ${breakpoints.desktop}px) {
    margin-top: ${heights.header.desktop / 10}px;
    padding-top: 44px;
  }
`;

interface LayoutMainProps {
  className?: string;
}

const LayoutMain: React.FC<LayoutMainProps> = ({ children, className }) => (
  <StyledLayoutMain className={className}>{children}</StyledLayoutMain>
);

export default LayoutMain;
